<template>
    <div class="col-12">
        <h1 class="my-3 h2 mt-0">{{ h1 }} <span v-if="(page?.h1 == null || page?.h1 == '') && (this.townDetails?.h1 == null || this.townDetails?.h1 == '')" :class="{ 'text-capitalize': locationIsTown && postcode }">{{ this.postcode && this.mountedSearch ? (locationIsTown ? this.postcode.toLowerCase() : this.postcode) : 'the UK' }}</span></h1>
      <div class="row">
            <div class="col-12 col-sm-10">
                <div v-if="townDetails?.content" v-html="townDetails.content" class="mb-md-4"></div>
                <template v-else-if="!postcode || !this.mountedSearch">
                    <p v-html="defaultText"></p>
                </template>
            </div>
        </div>
        <div class="row">
            <fitters-overview
                :fitters="updatedFitters"
                :postcode="postcode"
                :postcode-details="postcodeDetails"
                :mobile-fitting-slots="mobileFittingSlots"
                :mobile-fitting-route="mobileFittingRoute"
                :google-maps-api-key="googleMapsApiKey"
                :distance="distance"
                :has-reviews="hasReviews"
                :route="route"
                :view="view"
                :fitter-types="fitterTypes"
                :mounted-search="mountedSearch"
                :registration="registration"
                :image-base-path="imageBasePath"
            ></fitters-overview>
            <teleport to="body">
                <fitter-modal
                    v-if="modalOpen == true"
                    :postcode="postcode"
                    :fitter="selectedFitter"
                    :size-options="options"
                    :selected-app-date="selectedAppDate"
                    :selected-app-time="selectedAppTime"
                    :selected-fitting-times="selectedFittingTimes"
                    :mobile-fitting-slots="mobileFittingSlots"
                    :modal-open="modalOpen"
                    :basket-app-end-time="basket.app_end_time"
                    :image-base-path="imageBasePath"
                    :view="view"
                    @updatedFitterTimes="updateFittingTimes"
                    @closeModal="modalOpen = false"
                ></fitter-modal>
            </teleport>
        </div>
        <br>
        <alphabet-list
            :used-letters="usedLetters"
            :currentRoute="currentRoute"
            :default-letter="defaultLetter"
        ></alphabet-list>
        <br>
        <town-list
            :towns="towns"
            :default-letter="defaultLetter"
            :base="base"
        ></town-list>
    </div>
</template>

<script>
    import { Form as VeeForm, Field , ErrorMessage} from 'vee-validate';
    import * as yup from 'yup';

    export default {
        props: [
            'postcode',
            'fitters',
            'towns',
            'usedLetters',
            'currentRoute',
            'hasReviews',
            'googleMapsApiKey',
            'route',
            'mobileFittingSlots',
            'postcodeDetails',
            'distance',
            'view',
            'basket',
            'fitterTypes',
            'imageBasePath',
            'townDetails',
            'mobileFittingRoute',
            'mountedSearch',
            'defaultText',
            'registration',
            'imageBasePath',
            'page',
            'base'
        ],
        components: {
            VeeForm,
            Field,
            ErrorMessage
        },
        data() {
            const fnValidationSchema = yup.object({
                'postcode': yup.string().required('postcode is a required field'),
            });

            return {
                updatedFitters: this.fitters,
                selectedFitter: [],
                selectedAppDate: '',
                selectedAppTime: '',
                selectedFittingTimes: [],
                options: [],
	            modalOpen: false,
                defaultLetter: 'a',
                fnValidationSchema,
                locationIsTown: false
            }
        },
        mounted() {
            //removes loading placeholder - fixes CLS issue
            document.querySelector('#loadingPlaceholder').style.display = 'none';

            this.checkLocationIsTown();

            this.emitter.on('openFitterModal', data => {
                //Update fitter modal data
                this.selectedFitter = data.fitter;
                this.options = data.sizeOptions;
                this.selectedAppDate = data.selectedAppDate;
                this.selectedAppTime = data.selectedAppTime;
                this.selectedFittingTimes = data.selectedFittingTimes;
                this.modalOpen = true;
            });
        },
        methods: {
            checkLocationIsTown() {
                const townRegex = '^[a-zA-Z_ ]*$';
                const townCheck = this.postcode.match(townRegex);

                this.locationIsTown = townCheck ? true : false;
            },
            fittersUpdated: function(data) {
                this.updatedFitters = data;
            },
            updateFittingTimes: function(data) {
                _.forEach(this.updatedFitters, function(fitter, key) {
                    if(fitter.account_number == data.account_number) {
                        fitter.fitting_times = data.fitting_times;
                    }
                });
            }
        },
        computed: {
            h1() {
                return this.townDetails?.h1 != null && this.townDetails?.h1 != '' ? this.townDetails.h1 : (this?.page?.h1 ? this?.page?.h1 : ('Find your nearest ' + (this.mobileFittingRoute == true ? 'mobile fitter in ' : 'tyre service centre in ')));
            }
        }
    }
</script>

<style lang="scss" scoped>
    .fitters-column {
        height: 80vh;
        overflow-x: scroll;
    }
</style>